/**
 * to represent type of response segment 
 */
export enum ResponseSegmentType {
    TEXT = 'text',
    CODE = 'code',
    IMAGE= 'image'
}